module.exports = __webpack_public_path__ + "img/g-fpgh-bg.d7c10feb.png";